import {Component, EventEmitter, Input, OnInit, Output, TrackByFunction} from '@angular/core';
import {IVideo} from "../../../../sidebar/sidebar.component";
import {NewProject} from "../../../../../../interfaces/app.interfaces";
import {CreateVideoData, DeleteVideoData} from "./video/video.component";

@Component({
  selector: 'app-conversation-videocollection',
  templateUrl: './conversation-videocollection.component.html',
  styleUrl: './conversation-videocollection.component.scss'
})
export class ConversationVideocollectionComponent implements OnInit {

  constructor() {
  }

  @Input() videos: IVideo[] = [];
  @Input() videoCollection?: NewProject;

  @Output() onCreate: EventEmitter<CreateVideoData> = new EventEmitter<CreateVideoData>();
  @Output() onDelete: EventEmitter<DeleteVideoData> = new EventEmitter<DeleteVideoData>();

  trackByVideoId: TrackByFunction<IVideo> = (index, item) => item.tempId

  isFirstVideo(): boolean {
    return this.videos.length === 1;
  }

  handleCreate(createData: CreateVideoData): void {
    this.onCreate.emit(createData);
  }

  handleDelete(deleteData: DeleteVideoData): void {
    this.onDelete.emit(deleteData);
  }

  ngOnInit(): void {
  }

}
